import { render, staticRenderFns } from "./ScoreList.vue?vue&type=template&id=722390de"
import script from "./ScoreList.vue?vue&type=script&lang=js"
export * from "./ScoreList.vue?vue&type=script&lang=js"
import style0 from "./ScoreList.vue?vue&type=style&index=0&id=722390de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports